import { Skeleton, Stack, Typography } from "@mui/material";
import IChannel from "./IChannel";

interface IProps {
    channel?: IChannel;
}

export default function ChannelHeader({ channel }: IProps) {

    return (
        <Stack className="px-2 h-16 border-b-2" sx={{ borderColor: 'grey.50' }} direction='row' spacing={1} alignItems="center">
            {
                channel ?
                    <>
                        <img className="w-10 h-10 rounded-full" alt="" src={channel.image} />
                        <Typography sx={{ color: 'grey.800' }} className="text-xl font-medium grow overflow-hidden whitespace-nowrap overflow-ellipsis">{channel.name}</Typography>

                    </>
                :
                    <>
                        <Skeleton variant="circular" className="w-10 h-10"/>
                        <div className="grow"><Skeleton className="w-1/4" /></div>
                    </>
            }
        </Stack>
    )
}
